export default {"src":"/_next/static/media/telephone.ff43f818.svg","height":16,"width":16};